import { Pill } from "@clipboard-health/ui-components";

import {
  defaultPlacementApplicationStatusMap,
  PlacementApplicationStatus,
} from "../types/fetchPlacements.schema";

interface PlacementApplicationStatusChipProps {
  status: PlacementApplicationStatus;
}

export function PlacementApplicationStatusChip(props: PlacementApplicationStatusChipProps) {
  const { status } = props;

  let chipBackgroundColor: "info" | "success" | "warning";
  let chipLabel: string;

  switch (status) {
    case PlacementApplicationStatus.INTERVIEW: {
      chipBackgroundColor = "info";
      chipLabel = "Interview held";
      break;
    }

    case PlacementApplicationStatus.OFFER: {
      chipBackgroundColor = "success";
      chipLabel = "Offer made";
      break;
    }

    case PlacementApplicationStatus.HIRED: {
      chipBackgroundColor = "success";
      chipLabel = "Offer accepted";
      break;
    }

    default: {
      chipBackgroundColor = "info";
      chipLabel = defaultPlacementApplicationStatusMap[status]?.label;
      break;
    }
  }

  return (
    // If the chip label is not defined, don't render the chip
    chipLabel ? (
      <Pill
        variant="filled"
        size="small"
        label={chipLabel}
        color={(theme) => theme.palette[chipBackgroundColor].contrastText}
        iconColor={(theme) => theme.palette[chipBackgroundColor].contrastText}
        backgroundColor={(theme) => theme.palette[chipBackgroundColor].main}
        sx={{ width: "fit-content", alignSelf: "flex-start" }}
      />
    ) : (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <></>
    )
  );
}
